module.exports = __webpack_public_path__ + "images/emoji/outbox_tray.8488f50d45f5fb5ffcfc.png";